"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _reduxForm = require("redux-form");
var _isInt = _interopRequireDefault(require("validator/lib/isInt"));
var _slice2 = _interopRequireDefault(require("lodash/slice"));
var _domOnlyProps = _interopRequireDefault(require("cccisd-redux-form-helpers/dist/helpers/domOnlyProps.js"));
var _builder = _interopRequireDefault(require("./builder.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var validate = function validate(values, props) {
  var errors = {};
  var min = props.min,
    max = props.max;
  if (values.gap === undefined || !(0, _isInt["default"])(values.gap.toString(), {
    min: 1,
    max: max - min
  })) {
    errors.gap = "Value should be a whole number 1 to ".concat(max - min);
  }
  if (!errors.gap) {
    var length = Math.floor((max - min) / +values.gap) + 1;
    if (length > 51) {
      errors.length = 'You cannot generate more than 51 labels';
    }
  }
  return errors;
};
var Form = /*#__PURE__*/function (_React$Component) {
  _inherits(Form, _React$Component);
  function Form() {
    var _this;
    _classCallCheck(this, Form);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Form, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "_getNumbers", function () {
      var _this$props = _this.props,
        min = _this$props.min,
        max = _this$props.max,
        fields = _this$props.fields;
      var numbers = [];
      for (var i = min; i <= max; i += +fields.gap.value) {
        numbers.push(i);
      }
      return numbers;
    });
    _defineProperty(_assertThisInitialized(_this), "_renderHint", function () {
      var _this$props2 = _this.props,
        min = _this$props2.min,
        max = _this$props2.max,
        fields = _this$props2.fields;
      var exampleNumber = 11;
      var numbers = _this._getNumbers();
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: _builder["default"].labelsExample
      }, "Will generate ", Math.floor((max - min) / +fields.gap.value) + 1, " labels", ' (', (0, _slice2["default"])(numbers, 0, exampleNumber).join(', '), numbers.length > exampleNumber && ' ...', ')');
    });
    _defineProperty(_assertThisInitialized(_this), "_onSubmit", function (values) {
      var numbers = _this._getNumbers();
      _this.props.closeModal();
      _this.props.generateLabels(numbers, values.verticalPosition);
    });
    return _this;
  }
  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        handleSubmit = _this$props3.handleSubmit,
        _this$props3$fields = _this$props3.fields,
        gap = _this$props3$fields.gap,
        verticalPosition = _this$props3$fields.verticalPosition,
        errors = _this$props3.errors;
      return /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: handleSubmit(this._onSubmit)
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: gap,
        label: "Interval between numbers"
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("input", _extends({}, (0, _domOnlyProps["default"])(gap), {
        className: "form-control",
        style: {
          width: '50px',
          display: 'inline-block'
        }
      })), !errors.gap && this._renderHint())), errors.length && /*#__PURE__*/_react["default"].createElement("p", {
        className: "text-danger"
      }, errors.length), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: verticalPosition,
        label: "Label location"
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
        className: "radio-inline"
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({}, (0, _domOnlyProps["default"])(verticalPosition), {
        type: "radio",
        value: "bottom",
        checked: verticalPosition.value === 'bottom'
      })), ' ', "Bottom"), /*#__PURE__*/_react["default"].createElement("label", {
        className: "radio-inline"
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({}, (0, _domOnlyProps["default"])(verticalPosition), {
        type: "radio",
        value: "top",
        checked: verticalPosition.value === 'top'
      })), ' ', "Top"))), /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn btn-primary",
        onClick: handleSubmit(this._onSubmit)
      }, "Generate"));
    }
  }]);
  return Form;
}(_react["default"].Component);
_defineProperty(Form, "propTypes", {
  min: _propTypes["default"].number,
  max: _propTypes["default"].number,
  fields: _propTypes["default"].object,
  handleSubmit: _propTypes["default"].func,
  errors: _propTypes["default"].object,
  generateLabels: _propTypes["default"].func,
  closeModal: _propTypes["default"].func
});
var _default = exports["default"] = (0, _reduxForm.reduxForm)({
  form: 'generateLabelsForm',
  fields: ['gap', 'length', 'verticalPosition'],
  validate: validate
})(Form);